'use client';

import { useEffect } from 'react';
import type { AirbridgeShareContext } from '@apis/renewal/share';

function useAirbridgeShareContext(context: AirbridgeShareContext): void {
  const { description, imageUrl, profileName, shareUrl, type } = context;

  useEffect(() => {
    const registeredContext: WckAirbridgeShareContext = {
      type,
      shareUrl: shareUrl || window.location.href,
      imageUrl,
      profileName,
      description,
    };

    window.WCK_AIRBRIDGE_SHARE_CONTEXT = registeredContext;

    return () => {
      if (window.WCK_AIRBRIDGE_SHARE_CONTEXT === registeredContext) {
        delete window.WCK_AIRBRIDGE_SHARE_CONTEXT;
      }
    };
  }, [description, imageUrl, profileName, shareUrl, type]);
}

export default useAirbridgeShareContext;
